<script context="module" lang="ts">
  export type IHero = heroes & {
    buttons: hero_buttons[];
  };
</script>

<script lang="ts">
  import { writable } from 'svelte/store';
  import { onMount } from 'svelte';

  import Alert from '../Alert.svelte';
  import HeroTitleText1 from './HeroTitleText1.svelte';
  import HeroTitleText2 from './HeroTitleText2.svelte';
  import HeroTitleTextImageBottom1 from './HeroTitleTextImageBottom1.svelte';
  import HeroTitleTextImageLeft1 from './HeroTitleTextImageLeft1.svelte';
  import HeroTitleTextImageLeft2 from './HeroTitleTextImageLeft2.svelte';
  import HeroTitleTextImageRight1 from './HeroTitleTextImageRight1.svelte';
  import HeroTitleTextImageRight2 from './HeroTitleTextImageRight2.svelte';
  import HeroTitleTextImageRight3 from './HeroTitleTextImageRight3.svelte';
  import type { hero_buttons, heroes } from '@prisma/client';

  export let heros: IHero[];

  const current = writable(0);
  const hover = writable(false);
  let pause = false;
  $: pause = $hover;

  onMount(() => {
    if (heros.length > 1) {
      const interval = setInterval(() => {
        if (!pause) {
          current.update((c) => (c + 1) % heros.length);
        }
      }, 4000);

      return () => clearInterval(interval);
    }
  });
</script>

{#if heros.length > 0}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="relative overflow-hidden"
    on:mouseenter={() => ($hover = true)}
    on:mouseleave={() => ($hover = false)}
  >
    {#if heros.length > 1}
      <!--Carousel indicators-->
      <div
        class="absolute bottom-0 left-0 right-0 z-[2] mx-[15%] mb-4 flex list-none justify-center p-0"
      >
        {#each heros as hero, i}
          <button
            type="button"
            class="mx-[3px] box-content h-[4px] w-[30px] flex-initial cursor-pointer border-0 border-y-[10px] border-solid border-transparent bg-primary-500 bg-clip-padding p-0 -indent-[999px] opacity-50 transition-opacity duration-[600ms] ease-[cubic-bezier(0.25,0.1,0.25,1.0)] motion-reduce:transition-none"
            aria-current="true"
            aria-label={hero.title}
            on:click={() => ($current = i)}
          />
        {/each}
      </div>
    {/if}

    <!--Carousel items-->
    <div class="relative w-full after:clear-both after:block after:content-[''] max-h-[45rem]">
      {#each heros as hero, i}
        {#if $current == i}
          <div
            class="relative float-left -mr-[100%] w-full transition-transform duration-[600ms] ease-in-out motion-reduce:transition-none"
            style="backface-visibility: hidden"
          >
            {#if hero.type == 'title_text_1'}
              <HeroTitleText1 {hero} />
            {:else if hero.type == 'title_text_image_1'}
              <HeroTitleText2 {hero} />
            {:else if hero.type == 'title_text_image_right_1'}
              <HeroTitleTextImageRight1 {hero} />
            {:else if hero.type == 'title_text_image_right_2'}
              <HeroTitleTextImageRight2 {hero} />
            {:else if hero.type == 'title_text_image_right_3'}
              <HeroTitleTextImageRight3 {hero} />
            {:else if hero.type == 'title_text_image_left_1'}
              <HeroTitleTextImageLeft1 {hero} />
            {:else if hero.type == 'title_text_image_left_2'}
              <HeroTitleTextImageLeft2 {hero} />
            {:else if hero.type == 'title_text_image_bottom_1'}
              <HeroTitleTextImageBottom1 {hero} />
            {:else}
              <Alert severity="notice">
                Tipo de sección no soportada `{hero.type}`
              </Alert>
            {/if}
          </div>
        {/if}
      {/each}
    </div>
  </div>
{/if}
